import { SERVICES } from '../data/site';
import { Seo } from '../lib/seo';
import { PageHero, CTABand, LinkRow } from '../components/chrome';

const crumbs = [{ label: 'Home', href: '/' }, { label: 'Services' }];

export default function ServicesHub() {
  return (
    <div data-testid="page-services-hub">
      <Seo
        title="Laboratory Equipment Services: Procurement, Installation & Lifecycle | ToxGlobal Analytics"
        description="Fifteen services covering analytical equipment procurement, installation, commissioning, IQ/OQ/PQ validation, calibration, preventive maintenance, repair coordination, and lifecycle support nationwide."
        path="/services"
        breadcrumbs={crumbs}
      />
      <PageHero
        eyebrow="Services"
        lines="From purchase order to a working, supported instrument"
        sub="ToxGlobal Analytics is a single point of accountability between agencies, OEMs, and service providers. These fifteen services cover the full life of analytical equipment in government and regulated laboratories."
        breadcrumbs={crumbs}
        image={SERVICES[2].image}
        imageAlt={SERVICES[2].alt}
      />
      <section className="section-pad" data-testid="services-index">
        <div className="container-x border-t border-slate-200">
          {SERVICES.map((s, i) => <LinkRow key={s.slug} i={i} href={`/services/${s.slug}`} label={s.name} tag={s.tagline} />)}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
